<template>
    <div class="mt-5">
        <div>
            {{ $tc('messages.other_contacts') }}
        </div>

        <div v-if="contacts.length === 0">
            {{ $t('messages.no_contacts') }}
        </div>
        <ul class="mt-1">
            <li v-for="contact in contacts" :key="contact.id">
                <AppCard class="mt-1 md:mt-3">
                    <div class="flex items-center md:space-x-2">
                        <div v-if="contact.can_take_student" :title="$t('messages.can_take_student')">
                            <svg
                                class="w-4 h-4 inline-block text-green-300"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <svg
                                class="w-4 h-4 inline-block text-green-300"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                ></path>
                            </svg>
                        </div>
                        <div v-else :title="$t('messages.cannot_take_student')">
                            <svg
                                class="w-4 h-4 inline-block text-red-300"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                            <svg
                                class="w-4 h-4 inline-block text-red-300"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                                ></path>
                            </svg>
                        </div>
                        <InertiaLink
                            class="text-indigo-500"
                            :href="
                                route('student.contacts.show', {
                                    student: student.id,
                                    contact: contact.id,
                                })
                            "
                        >
                            {{ contact.full_name }}
                        </InertiaLink>
                        <span class="ml-1">({{ $t('messages.' + contact.relationship) }})</span>
                    </div>
                    <div>
                        <PhonesList :phones="contact.phones" :with-columns="false" />
                    </div>
                </AppCard>
            </li>
        </ul>
    </div>
</template>

<script>
import AppCard from '@/Shared/AppCard.vue';
import PhonesList from '@/Pages/Admin/Relatives/PhonesList.vue';

export default {
    name: 'StudentProfileContactList',
    components: {
        AppCard,
        PhonesList,
    },
    props: {
        student: {
            type: Object,
            required: true,
        },
        contacts: {
            type: Array,
            required: true,
        },
    },
};
</script>
